var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"Heading2"},[_vm._v(" 2018年8月1日に、「監査役監査の基礎知識 自己診断」を"),_c('br'),_vm._v(" リニューアルいたしました。（h2） ")])}]

export { render, staticRenderFns }